import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'operation-programmed-payments-frequency-form',
    templateUrl: './operation-programmed-payments-frequency-form.component.html',
    styleUrls: ['./operation-programmed-payments-frequency-form.component.scss'],
    standalone: false
})
export class OperationProgrammedPaymentsFrequencyFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      value: 'MONTHLY',
      label: 'Mensuel',
      suffix: { title: 'A' },
    },
    {
      value: 'QUARTERLY',
      label: 'Trimestriel',
      suffix: { title: 'B' },
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
